// extracted by css-extract-rspack-plugin
export default {"IssueBodyLoadingContainer":"IssueBodyLoading-module__IssueBodyLoadingContainer__x5ECe"};